import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { ISPCStore } from '../state-man/models/ispc-store.model';
import { UiService } from './ui.service';
import { LoggerService } from './logger.service';
import { User } from '../state-man/models/user.model';
import { DateTime } from 'luxon';

@Injectable({
  providedIn: 'root'
})
export class ISPCStoreService {

  constructor(
    private apiService: ApiService,
    private uiService: UiService
  ) { }
 
  public async getAll (user: User, last_update: string) : Promise<ISPCStore[] | null> {      
    try {
      const hasLatLong = user.latitude && user.longitude;
      const latLong = hasLatLong ? user.latitude + '/' + user.longitude : '44.967243/103.771556';
      if(!hasLatLong) {
        await this.uiService.showToast('Cannot determine your location. Please check your location settings.')
      }     
      console.log(last_update) 
      if (!last_update || last_update === '') last_update = DateTime.fromISO('1900-01-01T00:00:00.000Z').toISO() as string;
      console.log(last_update)
      const ret = await this.apiService.apiReturnsAny('get', 'ispc_store/active/' + latLong + '/' + last_update)
      return (ret && Array.isArray(ret)) ? ISPCStore.buildMany(ret) : null
    } 
    catch (error) {    
      LoggerService.log(error + 'ispc_store/active/')   
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')
      return null
    }
  }  

}
